import {  Component, inject, AfterViewInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { provideNativeDateAdapter } from '@angular/material/core';
import { select, Store } from '@ngrx/store';
import { NgForm } from '@angular/forms';
import { Area } from '../../../models/area';
import { Offer } from '../../../models/offer';
import { Division } from '../../../models/division';
import { PdfService } from '../../../services/pdf.service';
import { findAreasCatalogAct, findBenefitTypeCatalogAct, findDivisionsCatalogAct, findWithholdingTypeCatalogAct } from '../../../store/catalog-offer/catalog-offer.actions';
import { findOfferAct, recalculateOfferAct, resetOfferAct, saveOfferAct, 
         getSignaturesOfferAct, updateOfferAct, 
         sendSignaturesOfferAct,
         sendOperateOfferAct,
         deleteOfferAct} from '../../../store/offer/offer.actions';
import { ActivatedRoute } from '@angular/router';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { OfferBenefit } from '../../../models/offer-benefit';
import { EmployeeListService } from '../../../services/employee-list.service';
import { BenefitType } from '../../../models/benefit-type';
import { AlertaService } from '../../../services/alerta.service';
import { WithholdingType } from '../../../models/withholding-type';
import { PositionsService } from '../../../services/position.service';
import { Position } from '../../../models/position';

@Component({
  selector: 'app-offers-add',
  standalone: false,
  templateUrl: './offers-add.component.html',
  styleUrl: './offers-add.component.css',
  providers: [provideNativeDateAdapter()]
})

export class OffersAddComponent implements AfterViewInit{

  divisions: Division[] = [];
  areas: Area[] = [];
  offer: Offer = new Offer();
  violations: any;
  offerForm!: NgForm;
  isInTypeOffer!: boolean;
  loading: boolean = false;
  benefitTypes: BenefitType[] = [];
  withholdingTypes: WithholdingType[] = [];
  inputsCurrentDisable!: boolean;
  employeeNumberDisable!: boolean;
  positionNumberDisable!: boolean;

  private pdfService = inject(PdfService);
  private alerta = inject(AlertaService);

  columndefs : any[] = ['benefit', 'typeB','descriptionC','valueCalculateC','descriptionO','valueCalculateO'];
  columndefsW : any[] = ['withholding', 'typeB','descriptionC','valueCalculateC','descriptionO','valueCalculateO'];

  ngAfterViewInit() {
    
  }

  ngOnInit(): void {
    this.offerStore.dispatch(resetOfferAct());
    this.route.paramMap.subscribe(params => {
      const id: number = + (params.get('id') || '0');
      if(id > 0){
        this.offerStore.dispatch(findOfferAct({ id }));
      }else{
        this.offer = new Offer();
        this.offer.active = true;
        this.isInTypeOffer = false;
        this.loading = false;
      }
    });

    this.catalogOfferStore.dispatch(findDivisionsCatalogAct());
    this.catalogOfferStore.dispatch(findAreasCatalogAct());
    this.catalogOfferStore.dispatch(findBenefitTypeCatalogAct());
    this.catalogOfferStore.dispatch(findWithholdingTypeCatalogAct());

  }

  constructor(
    private offerStore: Store<{offerRdc: any}>,
    private catalogOfferStore: Store<{catalogOfferRdc: any}>,
    private route: ActivatedRoute,
    private cd: ChangeDetectorRef,
    private employeeService: EmployeeListService,
    private positionService: PositionsService
  ){
    this.offer = new Offer();

    this.offerStore.pipe(
        select('offerRdc'),
        map(state => ({ // filtra cuando cambian las propiedades que se usan en este componente
          offer: state.offer,
          violations: state.violations,
          loading: state.loading
        })),
        // evita repeticiones
        distinctUntilChanged((prev, curr) =>
          JSON.stringify(prev) === JSON.stringify(curr)
        )
      ).subscribe(({ offer, violations, loading }) => {
      this.violations = violations;
      this.offer = JSON.parse(JSON.stringify(offer)); // o mejor: _.cloneDeep(offer)
      if (!this.offer.position) {
        this.offer.position = {} as Position;
      }
      this.offer.offerBenefitList = this.offer.offerBenefitList.map((row, index) => ({
        ...row,
        rowIndex: index
      }));
      const orderPriority: Record<string, number> = {
        'SAL_PRE': 0,
        'COM_BON': 1,
        'BEN': 2
      };
      const attributePriority: Record<string, number> = {
        'sueldoBase': 0,
        'aguinaldo': 1
      };
      this.offer.offerBenefitList = [...this.offer.offerBenefitList].sort((a, b) => {
        const currA = a.currentBenefitConfiguration?.benefit?.description?.trim() || '';
        const offA  = a.offeredBenefitConfiguration?.benefit?.description?.trim() || '';
        const outA  = a.currentDescriptionOut?.trim() || '';

        const currB = b.currentBenefitConfiguration?.benefit?.description?.trim() || '';
        const offB  = b.offeredBenefitConfiguration?.benefit?.description?.trim() || '';
        const outB  = b.currentDescriptionOut?.trim() || '';

        const hasPrimaryA = !!(currA || offA); // tiene current u offered
        const hasPrimaryB = !!(currB || offB);

        //#################################################################################
        // 1) Ordenar primero por benefitType.code (current, offered, o benefitTypeOut)
          const benefitTypeCodeA = a.currentBenefitConfiguration?.benefit?.benefitType?.code || 
          a.offeredBenefitConfiguration?.benefit?.benefitType?.code || 
          a.benefitTypeOut?.code || '';

        const benefitTypeCodeB = b.currentBenefitConfiguration?.benefit?.benefitType?.code || 
          b.offeredBenefitConfiguration?.benefit?.benefitType?.code || 
          b.benefitTypeOut?.code || '';

        // Si benefitTypeCodeA es diferente de benefitTypeCodeB, ordenarlos por ese campo
        const priorityA = orderPriority[benefitTypeCodeA] ?? 999;
        const priorityB = orderPriority[benefitTypeCodeB] ?? 999;

        if (priorityA !== priorityB) {
          return priorityA - priorityB;
        }

        // 2) Los que tienen atributo "sueldoBase" o "aguinaldo" primero
        // Orden por atributo (sueldoBase primero, luego aguinaldo)
        const attrA = a.currentBenefitConfiguration?.benefit?.attribute || a.offeredBenefitConfiguration?.benefit?.attribute || '';
        const attrB = b.currentBenefitConfiguration?.benefit?.attribute || b.offeredBenefitConfiguration?.benefit?.attribute || '';

        const attrPriorityA = attributePriority[attrA] ?? 999;
        const attrPriorityB = attributePriority[attrB] ?? 999;

        if (attrPriorityA !== attrPriorityB) {
          return attrPriorityA - attrPriorityB;
        }
        //#################################################################################
        // 1) Los que tienen primary primero; los de solo 'out' al final
        if (hasPrimaryA !== hasPrimaryB) return hasPrimaryA ? -1 : 1;

        // 2) Dentro de los que tienen primary: por current si existe, si no por offered
        if (hasPrimaryA) {
          const keyA = currA || offA;
          const keyB = currB || offB;

          const cmp = keyA.localeCompare(keyB, 'es', { sensitivity: 'base' });
          if (cmp !== 0) return cmp;

          // tie-break opcional con out
          if (outA && outB) return outA.localeCompare(outB, 'es', { sensitivity: 'base' });
          return 0;
        }

        // 3) Ambos son "solo out": ordénalos por currentDescriptionOut
        if (!outA && !outB) return 0;
        if (!outA) return 1;
        if (!outB) return -1;
        return outA.localeCompare(outB, 'es', { sensitivity: 'base' });
      });
      
      this.offer.offerSignatures.sort((a, b) => a.number - b.number);
      this.loading = loading;
      this.cd.markForCheck(); // fuerza la actualización de la vista
      //console.log("cargando " + this.loading);

      if(this.offer.typeOffer == 'IN'){
        this.isInTypeOffer = true;
        this.inputsCurrentDisable = true;
        this.employeeNumberDisable = true;
        if(this.offer.employee?.employeeNumber == '0'){
          this.inputsCurrentDisable = false;
        }
      }else{
        this.isInTypeOffer = false;
        this.employeeNumberDisable = false;
      }

      if(this.offerForm){
      
      Object.keys(this.offerForm.controls).forEach(controlName => {
        const control = this.offerForm.controls[controlName];
        if (this.violations[controlName]) {
          control.setErrors({ backend: true }); // Marca error
        }
      });
    }
    });

    this.catalogOfferStore.pipe(
      select('catalogOfferRdc'),
      map(state => ({ // filtra cuando cambian las propiedades que se usan en este componente
        divisions: state.divisions,
        areas: state.areas,
        benefitTypes: state.benefitTypes,
        withholdingTypes: state.withholdingTypes
      })),
      // evita repeticiones
      distinctUntilChanged((prev, curr) =>
        JSON.stringify(prev) === JSON.stringify(curr)
      )
    ).subscribe(({ divisions, areas, benefitTypes, withholdingTypes }) => {
      this.divisions = divisions;
      this.areas = areas;
      this.benefitTypes = benefitTypes;
      this.withholdingTypes = withholdingTypes;
    });
    
  }

  onEmployeeNumberChange(employeeNumber: string): void {
    //console.log('Número de empleado:', employeeNumber);
    if(employeeNumber == '0'){
      this.inputsCurrentDisable = false;
    }else{
      this.loading = true;
      this.cd.markForCheck(); // <- importante
    
      this.employeeService.findEmployeeByNumber(employeeNumber).subscribe({
        next: (emp) => {
          this.alerta.information("Se encontro el Empleado: " + emp.person.fullName);
          this.offer.employee = JSON.parse(JSON.stringify(emp));
          this.loading = false;
          this.cd.markForCheck(); // <- actualiza la vista
        },
        error: (err) => {
          //console.error('Error al obtener empleado' + err);
          if(err.status == '404'){
            this.alerta.information("No se tiene registrado el Empleado.");
          }else{
            this.alerta.error("Se presento un error. Inténtalo más tarde.: ", {detail: err.message});
          }
          this.offer.employee!.employeeNumber = '0';
          this.loading = false;
          this.inputsCurrentDisable = false;
          this.cd.markForCheck(); // <- actualiza la vista
          
        }
      });
      this.inputsCurrentDisable = true;
    }
  }
  onPositionNumberChange(positionNum: string): void {
    //console.log('Número de empleado:', positionNum);
    if(positionNum == null || positionNum == undefined || positionNum == ''){
      this.offer.position = {} as Position;
    }else{
      this.loading = true;
      this.cd.markForCheck(); // <- importante
    
      this.positionService.findPositionByNumber(positionNum).subscribe({
        next: (positionRes) => {
          this.alerta.information("Se encontro el Puesto: " + positionRes.positionNum + ' - ' + positionRes.description);
          this.offer.position = JSON.parse(JSON.stringify(positionRes));
          this.loading = false;
          this.cd.markForCheck(); // <- actualiza la vista
        },
        error: (err) => {
          //console.error('Error al obtener empleado' + err);
          if(err.status == '404'){
            this.alerta.information("No se tiene registrado el Puesto.");
          }else{
            this.alerta.error("Se presento un error. Inténtalo más tarde.: ", {detail: err.message});
          }
          //this.offer.position = null;
          //if (!this.offer.position) {
            this.offer.position = {} as Position;
          //}

          this.loading = false;
          //this.inputsCurrentDisable = false;
          this.cd.markForCheck(); // <- actualiza la vista
          
        }
      });
      this.inputsCurrentDisable = true;
    }
  }
  

  onSubmitOffer(offerForm: NgForm): void {
    this.loading = true;
    this.offerForm = offerForm;
    const offerCopy = JSON.parse(JSON.stringify(this.offer));

    if(this.isInTypeOffer){
      offerCopy.typeOffer = 'IN';
      offerCopy.applicant = null;
    }else{
      offerCopy.typeOffer = 'OUT';
      offerCopy.employee = null;
    }

    if(offerCopy.area.id == 0)
      offerCopy.area = null;
   
    if(offerCopy.division.id == 0)
      offerCopy.division = null;

    if(offerCopy.position.id == 0 || offerCopy.position.id == undefined || offerCopy.position.id == null)
      offerCopy.position = null;

    if(offerCopy.employee != null){
      if(offerCopy.employee.area.id == 0)
        offerCopy.employee.area = null;
    
      if(offerCopy.employee.division.id == 0)
        offerCopy.employee.division = null;
    }

    if (offerCopy.id > 0) {
      this.offerStore.dispatch(updateOfferAct({ offerUpdated: offerCopy }))
    } else {
      this.offerStore.dispatch(saveOfferAct({ offerNew: offerCopy }))
    }
  }

  recalculateOffer() {
    //this.loading = true;
    const offerCopy = JSON.parse(JSON.stringify(this.offer));
    if(this.isInTypeOffer){
      offerCopy.typeOffer = 'IN';
      offerCopy.applicant = null;
    }else{
      offerCopy.typeOffer = 'OUT';
      offerCopy.employee = null;
    }
    this.offerStore.dispatch(recalculateOfferAct({offerRecalculate: offerCopy}))
  }

  getSignatures(){
    //this.loading = true;
    const offerCopy = JSON.parse(JSON.stringify(this.offer));
    if(this.isInTypeOffer){
      offerCopy.typeOffer = 'IN';
      offerCopy.applicant = null;
    }else{
      offerCopy.typeOffer = 'OUT';
      offerCopy.employee = null;
    }
    this.offerStore.dispatch(getSignaturesOfferAct({offerSignature: offerCopy}));
  }

  sendSignatures(){
    const offerCopy = JSON.parse(JSON.stringify(this.offer));
    this.alerta.question('Estas seguro?', 'Al avanzar ya no se podran realizar cambios', 'Si, avanzar', {
      onAccept: () => {
        this.loading = true;
        this.offerStore.dispatch(sendSignaturesOfferAct({offerSignature: offerCopy}));
      }});
  }

  applyOffer(){
    const offerCopy = JSON.parse(JSON.stringify(this.offer));
    this.alerta.question('Estas seguro?', 'Con esta acción el aplicante se registrara como Empleado', 'Si, aplicar', {
      onAccept: () => {
        this.loading = true;
        this.offerStore.dispatch(sendOperateOfferAct({offerOperate: offerCopy}));
      }});
  }

  deleteOffer(){
    const offerCopy = JSON.parse(JSON.stringify(this.offer));
    this.alerta.question('Estas seguro?', 'Se eliminara de forma permanente', 'Si, eliminar', {
      onAccept: () => {
        this.loading = true;
        this.offerStore.dispatch(deleteOfferAct({offerId: offerCopy.id}));
      }});
  }
  
  printOffer(){
    this.loading = true;
    this.pdfService.printOffer(this.offer.id).subscribe({
      next: (response: Blob) => {
        const fileURL = URL.createObjectURL(response);
        this.loading = false;
        window.open(fileURL, '_blank');
      },
      error: (error) => {
        this.loading = false;
        this.alerta.error("No se pudo generar el PDF. Inténtalo más tarde.: ", {detail: error.message});
      }
    });
  }
  addBenefit(){
    const newBenefit = new OfferBenefit();
    newBenefit.currentBenefitConfiguration = null;
    newBenefit.offeredBenefitConfiguration = null;

    this.offer.offerBenefitList = [...this.offer.offerBenefitList, newBenefit];
    this.offer.offerBenefitList = this.offer.offerBenefitList.map((row, index) => ({
      ...row,
      rowIndex: index
    }));
  }

  compareDivisions = (a: any, b: any) => a?.id === b?.id;
  compareAreas = (a: any, b: any) => a?.id === b?.id;
  compareUsers = (u1: any, u2: any): boolean => {
    return u1 && u2 ? u1.id === u2.id : u1 === u2;
  };
  compareBenefitTypes = (a: any, b: any) => a?.id === b?.id;
  
  isConfigPresent(row: any): boolean {
    return row.offeredBenefitConfiguration == null && row.currentBenefitConfiguration == null;
  }

  compareWithholdingTypes = (a: any, b: any) => a?.id === b?.id;
  isConfigPresentWithholding(row: any): boolean {
    return row.offeredWithholdingConfiguration == null && row.currentWithholdingConfiguration == null;
  }
    
}
